<template>
  <div style="margin-top: 8px">
    <v-tabs v-model="tab" :height="25">
      <v-tabs-slider color="#3be287"></v-tabs-slider>
      <v-tab v-for="item in tabInfoSatellite" :key="item">{{ item }}</v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab">
      <v-tab-item v-for="item in tabInfoSatellite" :key="item">
        <v-container v-if="item === 'Info'">
          <v-data-table
            :headers="headerTable"
            :items="listInfoSatellite"
            :height="300"
            hide-default-header
            show
            hide-default-footer
            style="width: 100%"
            dense
          ></v-data-table>
        </v-container>
        <v-container v-if="item === 'Orbital elements'">
          <v-data-table
            :headers="headerTable"
            :items="listOrbitalElementSatellite"
            :height="300"
            hide-default-header
            show
            hide-default-footer
            style="width: 100%"
            dense
          ></v-data-table>
        </v-container>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>
<script>
import defense from '../../mixins/defense'
export default {
  name: 'ScreeningCatalogueAnalysisSatelliteInfoCard',
  props: {
    infoSatellite: {
      type: Object
    }
  },
  mixins: [defense],
  data() {
    return {
      tabInfoSatellite: ['Info', 'Orbital elements'],
      tab: null,
      listInfoSatellite: [],
      listOrbitalElementSatellite: [],
      headerTable: [
        { text: 'Name', value: 'name' },
        { text: 'Value', value: 'value' }
      ],
      context: 'SpaceObjectCatalogueItem'
    }
  },
  components: {},
  watch: {
    infoSatellite() {
      this.updateInfoSatellite(this.infoSatellite)
    }
  },
  computed: {},
  mounted() {
    this.updateInfoSatellite(this.infoSatellite)
  },
  methods: {
    updateInfoSatellite(infoSatellite) {
      this.listInfoSatellite = [
        this.getOneLineInfoSatellite('name', infoSatellite),
        this.getOneLineInfoSatellite('country', infoSatellite),
        this.getOneLineInfoSatellite('noradId', infoSatellite),
        this.getOneLineInfoSatellite('objectType', infoSatellite),
        this.getOneLineInfoSatellite('decayDate', infoSatellite),
        this.getOneLineInfoSatellite('site', infoSatellite),
        this.getOneLineInfoSatellite('launch', infoSatellite),
        this.getOneLineInfoSatellite('launchNum', infoSatellite),
        this.getOneLineInfoSatellite('launchPiece', infoSatellite),
        this.getOneLineInfoSatellite('rcsSize', infoSatellite)
      ]
      this.listOrbitalElementSatellite = [
        this.getOneLineInfoSatellite('period', infoSatellite),
        this.getOneLineInfoSatellite('perigee', infoSatellite),
        this.getOneLineInfoSatellite('apogee', infoSatellite),
        this.getOneLineInfoSatellite('inclination', infoSatellite)
      ]
    },

    getOneLineInfoSatellite(pathInfo, infoSatellite) {
      let valueToDisplay
      if (
        infoSatellite[pathInfo] != undefined &&
        infoSatellite[pathInfo] !== ''
      ) {
        valueToDisplay = this.getDisplayValueFromPathFieldDescription(
          infoSatellite[pathInfo],
          [pathInfo],
          this.context
        )
      } else {
        valueToDisplay = 'no data available'
      }
      return {
        name: this.getLabelWithUnitFromPathFieldDescription(
          [pathInfo],
          this.context
        ),
        value: valueToDisplay
      }
    }
  }
}
</script>
<style></style>
